import { IconProps } from '../types';

function SquareCombinedSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className || 'h-5 w-5'}
    >
      <path
        id={id}
        fillRule="evenodd"
        d="M2,2h16v16H2V2z M4,4v12h12V4H4z M6,6h3v3H6V6z M11,6h3v3h-3V6z M6,11h3v3H6V11z M11,11h3v3h-3V11z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default SquareCombinedSolidIcon;
